<template>
  <div v-if="self_arr.length > 0" class="sort-block">
    <div ref="arrs" class="sort-arrs">
      <div
        v-for="item in self_arr"
        :key="item"
        :title="item"
        class="sort-item">
        {{item}}
        <span class="del-btn" @click="del(item)"><i class="el-icon-close"/></span>
      </div>
    </div>
  </div>
</template>

<script>
// 排序块
// 接受一个标题及要排序的数组
export default {
  model: {
    prop: 'arr',
    event: 'change'
  },
  props: {
    title: String,
    arr: Array,
  },
  data() {
    return {
      self_arr: [],
      ori_arr: [],
      sortable: null
    }
  },
  watch: {
    arr: {
      immediate: true,
      handler(v) {
        if (v.length !== this.ori_arr.length) {
          this.ori_arr = JSON.parse(JSON.stringify(v))
        }
        this.self_arr = JSON.parse(JSON.stringify(v));
      }
    }
  },
  methods: {
    del(item) {
      this.$emit("change", this.self_arr.filter(i => i !== item));
    }
  },
  created() {
    this.$nextTick(() => {
      this.sortable = Sortable.create(this.$refs.arrs, {
        handler: ".sort-item",
        onEnd: (evt) => {
          let {newIndex, oldIndex} = evt;
          const _copy = [].concat(this.self_arr);
          const [file] = _copy.splice(oldIndex, 1)
          _copy.splice(newIndex,0,file)
          this.$nextTick(() => {
            this.self_arr = _copy
            this.$emit("change", this.self_arr)
          })
        }
      })
    })
  },
  beforeDestroy() {
    this.sortable && this.sortable.destroy()
  }
}
</script>

<style lang="scss" scoped>
.sort-block {
  .sort-title {
    font-size: 16px;
    flex: 1;
  }
  .sort-row {
    margin: 10px 0;
    display: flex;
    align-items: center;
  }
  .sort-arrs {
    display: flex;
    flex-wrap: wrap;

    .sort-item {
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 3px 10px;
      font-size: 13px;
      line-height: 20px;
      white-space: nowrap;
      background: #fafafa;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      cursor: move;
      position: relative;
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 30px;

      .del-btn {
        position: absolute;
        width: 28px;
        top: 0;
        right: 0;
        bottom: 0;
        cursor: pointer;
        display: none;
        justify-content: center;
        align-items: center;
      }

      &:hover {
        .del-btn {
          display: flex;
        }
      }
      
    }
  }
}
</style>